import React, { Component } from 'react';
import getApiBaseUrl from '../utils/apiConfig';
import { Card, Button, Table, Form, Modal } from 'react-bootstrap';
import AsyncStorage from '@react-native-async-storage/async-storage';

class Employees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storeId: null,
      storeName: '',
      employees: [],
      payouts: [],
      loading: true,
      showAddModal: false,
      showEditModal: false,
      showPayoutHistoryModal: false,
      selectedEmployee: null,

      // Form fields
      formEmployeeNumber: '',
      formEmployeeName: '',
      formDogeAddress: '',
      formBtcAddress: '',
      formLtcAddress: '',
      formNotes: '',
      formActive: true,

      // Filter fields
      filterEmployeeId: '',
      filterStartDate: '',
      filterEndDate: '',
      filterStatus: 'all',

      error: null
    };
  }

  async componentDidMount() {
    try {
      // Get store info from AsyncStorage
      const storeId = await AsyncStorage.getItem('store-id');
      const storeName = await AsyncStorage.getItem('store-name') || 'My Store';

      if (!storeId) {
        this.setState({
          error: 'No active store found. Please select a store first.',
          loading: false
        });
        return;
      }

      this.setState({ storeId, storeName });
      await this.loadEmployees(storeId);
    } catch (error) {
      console.error('Error loading data:', error);
      this.setState({
        error: 'Failed to load employee data',
        loading: false
      });
    }
  }

  async loadEmployees(storeId = this.state.storeId) {

    try {
      const apiUrl = await AsyncStorage.getItem('apiUrl') || getApiBaseUrl();
      const response = await fetch(`${apiUrl}/employees/store/${storeId}?active=true`);
      const data = await response.json();

      if (data.success) {
        this.setState({
          employees: data.employees,
          loading: false,
          error: null
        });
      } else {
        this.setState({
          error: data.error || 'Failed to load employees',
          loading: false
        });
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
      this.setState({
        error: 'Failed to fetch employees',
        loading: false
      });
    }
  }

  async loadPayoutHistory(employeeId = null) {
    const { storeId, filterStartDate, filterEndDate, filterStatus } = this.state;

    try {
      const apiUrl = await AsyncStorage.getItem('apiUrl') || getApiBaseUrl();

      let url = `${apiUrl}/employees/store/${storeId}/payouts?`;
      if (employeeId) url += `employee_id=${employeeId}&`;
      if (filterStartDate) url += `start_date=${filterStartDate}&`;
      if (filterEndDate) url += `end_date=${filterEndDate}&`;
      if (filterStatus && filterStatus !== 'all') url += `status=${filterStatus}`;

      const response = await fetch(url);
      const data = await response.json();

      if (data.success) {
        this.setState({
          payouts: data.payouts,
          error: null
        });
      } else {
        this.setState({
          error: data.error || 'Failed to load payout history'
        });
      }
    } catch (error) {
      console.error('Error fetching payout history:', error);
      this.setState({
        error: 'Failed to fetch payout history'
      });
    }
  }

  handleShowAddModal = () => {
    this.setState({
      showAddModal: true,
      formEmployeeNumber: '',
      formEmployeeName: '',
      formDogeAddress: '',
      formBtcAddress: '',
      formLtcAddress: '',
      formNotes: '',
      formActive: true,
      error: null
    });
  };

  handleCloseAddModal = () => {
    this.setState({ showAddModal: false });
  };

  handleShowEditModal = (employee) => {
    this.setState({
      showEditModal: true,
      selectedEmployee: employee,
      formEmployeeNumber: employee.employee_number || '',
      formEmployeeName: employee.employee_name || '',
      formDogeAddress: employee.doge_address || '',
      formBtcAddress: employee.btc_address || '',
      formLtcAddress: employee.ltc_address || '',
      formNotes: employee.notes || '',
      formActive: employee.active !== false,
      error: null
    });
  };

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedEmployee: null
    });
  };

  handleShowPayoutHistory = async (employee) => {
    this.setState({
      showPayoutHistoryModal: true,
      selectedEmployee: employee,
      filterEmployeeId: employee.id
    });
    await this.loadPayoutHistory(employee.id);
  };

  handleClosePayoutHistory = () => {
    this.setState({
      showPayoutHistoryModal: false,
      selectedEmployee: null,
      filterEmployeeId: '',
      payouts: []
    });
  };

  handleAddEmployee = async () => {
    const {
      storeId,
      formEmployeeNumber,
      formEmployeeName,
      formDogeAddress,
      formBtcAddress,
      formLtcAddress,
      formNotes
    } = this.state;

    // Validation
    if (!formEmployeeName.trim()) {
      alert('Employee name is required');
      return;
    }

    if (!formDogeAddress.trim() && !formBtcAddress.trim() && !formLtcAddress.trim()) {
      alert('At least one cryptocurrency address is required');
      return;
    }

    try {
      const apiUrl = await AsyncStorage.getItem('apiUrl') || getApiBaseUrl();

      const response = await fetch(`${apiUrl}/employees`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          store_id: storeId,
          employee_number: formEmployeeNumber.trim() || null,
          employee_name: formEmployeeName.trim(),
          doge_address: formDogeAddress.trim() || null,
          btc_address: formBtcAddress.trim() || null,
          ltc_address: formLtcAddress.trim() || null,
          notes: formNotes.trim() || null,
          created_by: 'admin_ui'
        })
      });

      const data = await response.json();

      if (data.success) {
        alert('Employee added successfully!');
        this.handleCloseAddModal();
        await this.loadEmployees();
      } else {
        alert(`Error: ${data.error || 'Failed to add employee'}`);
      }
    } catch (error) {
      console.error('Error adding employee:', error);
      alert('Failed to add employee');
    }
  };

  handleUpdateEmployee = async () => {
    const {
      selectedEmployee,
      formEmployeeNumber,
      formEmployeeName,
      formDogeAddress,
      formBtcAddress,
      formLtcAddress,
      formNotes,
      formActive
    } = this.state;

    if (!selectedEmployee) return;

    // Validation
    if (!formEmployeeName.trim()) {
      alert('Employee name is required');
      return;
    }

    try {
      const apiUrl = await AsyncStorage.getItem('apiUrl') || getApiBaseUrl();

      const response = await fetch(`${apiUrl}/employees/${selectedEmployee.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          employee_number: formEmployeeNumber.trim() || null,
          employee_name: formEmployeeName.trim(),
          doge_address: formDogeAddress.trim() || null,
          btc_address: formBtcAddress.trim() || null,
          ltc_address: formLtcAddress.trim() || null,
          notes: formNotes.trim() || null,
          active: formActive
        })
      });

      const data = await response.json();

      if (data.success) {
        alert('Employee updated successfully!');
        this.handleCloseEditModal();
        await this.loadEmployees();
      } else {
        alert(`Error: ${data.error || 'Failed to update employee'}`);
      }
    } catch (error) {
      console.error('Error updating employee:', error);
      alert('Failed to update employee');
    }
  };

  handleDeleteEmployee = async (employee) => {
    const confirm = window.confirm(
      `Are you sure you want to deactivate ${employee.employee_name}? This will set their status to inactive.`
    );

    if (!confirm) return;

    try {
      const apiUrl = await AsyncStorage.getItem('apiUrl') || getApiBaseUrl();

      const response = await fetch(`${apiUrl}/employees/${employee.id}`, {
        method: 'DELETE'
      });

      const data = await response.json();

      if (data.success) {
        alert('Employee deactivated successfully');
        await this.loadEmployees();
      } else {
        alert(`Error: ${data.error || 'Failed to deactivate employee'}`);
      }
    } catch (error) {
      console.error('Error deactivating employee:', error);
      alert('Failed to deactivate employee');
    }
  };

  formatCryptoAmount(amount, crypto) {
    if (!amount || amount === 0) return '-';
    const decimals = crypto === 'btc' ? 8 : 2;
    return parseFloat(amount).toFixed(decimals);
  }

  formatDate(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  }

  renderEmployeeForm() {
    const {
      formEmployeeNumber,
      formEmployeeName,
      formDogeAddress,
      formBtcAddress,
      formLtcAddress,
      formNotes,
      formActive,
      showEditModal
    } = this.state;

    return (
      <>
        <Form.Group className="mb-3">
          <Form.Label>Employee Number (Optional)</Form.Label>
          <Form.Control
            type="text"
            placeholder="e.g., EMP001"
            value={formEmployeeNumber}
            onChange={(e) => this.setState({ formEmployeeNumber: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Employee Name *</Form.Label>
          <Form.Control
            type="text"
            placeholder="Full name"
            value={formEmployeeName}
            onChange={(e) => this.setState({ formEmployeeName: e.target.value })}
            required
          />
        </Form.Group>

        <Card className="mb-3" style={{ borderLeft: '4px solid #BA9F33' }}>
          <Card.Body>
            <h6>DOGE Address</h6>
            <Form.Control
              type="text"
              placeholder="Dogecoin address (optional)"
              value={formDogeAddress}
              onChange={(e) => this.setState({ formDogeAddress: e.target.value })}
            />
          </Card.Body>
        </Card>

        <Card className="mb-3" style={{ borderLeft: '4px solid #F7931A' }}>
          <Card.Body>
            <h6>BTC Address</h6>
            <Form.Control
              type="text"
              placeholder="Bitcoin address (optional)"
              value={formBtcAddress}
              onChange={(e) => this.setState({ formBtcAddress: e.target.value })}
            />
          </Card.Body>
        </Card>

        <Card className="mb-3" style={{ borderLeft: '4px solid #345D9D' }}>
          <Card.Body>
            <h6>LTC Address</h6>
            <Form.Control
              type="text"
              placeholder="Litecoin address (optional)"
              value={formLtcAddress}
              onChange={(e) => this.setState({ formLtcAddress: e.target.value })}
            />
          </Card.Body>
        </Card>

        <Form.Group className="mb-3">
          <Form.Label>Notes</Form.Label>
          <Form.Control
            as="textarea"
            rows={2}
            placeholder="e.g., Server - Evening shifts"
            value={formNotes}
            onChange={(e) => this.setState({ formNotes: e.target.value })}
          />
        </Form.Group>

        {showEditModal && (
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              label="Active Employee"
              checked={formActive}
              onChange={(e) => this.setState({ formActive: e.target.checked })}
            />
          </Form.Group>
        )}

        <div className="text-muted small">
          * At least one cryptocurrency address is required
        </div>
      </>
    );
  }

  renderEmployeeManagement() {
    const {
      storeName,
      employees,
      error,
      showAddModal,
      showEditModal,
      showPayoutHistoryModal,
      selectedEmployee,
      payouts,
      filterStartDate,
      filterEndDate,
      filterStatus
    } = this.state;

    // Detect mobile
    const isMobile = window.innerWidth < 768;

    return (
      <>
        <div style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          backgroundColor: '#f5f5f5'
        }}>
        {/* Fixed Header - ALWAYS VISIBLE */}
        <div style={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          backgroundColor: 'white',
          borderBottom: '1px solid #dee2e6',
          paddingTop: isMobile ? 'calc(12px + env(safe-area-inset-top, 0px))' : 'calc(16px + env(safe-area-inset-top, 0px))',
          paddingBottom: isMobile ? '12px' : '16px',
          paddingLeft: isMobile ? '16px' : '24px',
          paddingRight: isMobile ? '16px' : '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: isMobile ? '60px' : '70px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}>
          <div>
            <h4 style={{ margin: 0, fontSize: isMobile ? '18px' : '22px', fontWeight: '600' }}>
              Employee Management
            </h4>
            {!isMobile && (
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#666' }}>{storeName}</p>
            )}
          </div>
          <button
            className="home-button"
            onClick={() => window.location.href = '/admin'}
            style={{
              minWidth: isMobile ? '70px' : '80px',
              padding: isMobile ? '8px 12px' : '10px 16px',
              fontSize: isMobile ? '14px' : '16px'
            }}
          >
            ← Admin
          </button>
        </div>

        {/* Scrollable Content Area */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: isMobile ? '16px' : '24px'
        }}>
          {/* Store name - Mobile only */}
          {isMobile && (
            <div style={{ marginBottom: '16px', color: '#6c757d', fontSize: '14px' }}>
              {storeName}
            </div>
          )}

          {/* Add Employee Button - Full width on mobile */}
          <div style={{ marginBottom: '20px' }}>
            <button
              className="btn-primary"
              onClick={this.handleShowAddModal}
              style={{
                backgroundColor: '#28a745',
                width: isMobile ? '100%' : 'auto',
                padding: isMobile ? '14px' : '12px 20px',
                fontSize: '16px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#218838'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#28a745'}
            >
              <span style={{ fontSize: '20px', fontWeight: 'bold' }}>+</span>
              Add Employee
            </button>
          </div>

          {error && (
            <div style={{ backgroundColor: '#fee', border: '1px solid #fcc', marginBottom: '20px', padding: '16px', borderRadius: '8px' }}>
              <p style={{ color: '#c00', margin: 0 }}>{error}</p>
            </div>
          )}

          <h5 style={{ marginBottom: '16px', fontSize: isMobile ? '16px' : '18px', fontWeight: '600' }}>
            Active Employees ({employees.length})
          </h5>

          {employees.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '60px 20px',
              background: '#f8f9fa',
              borderRadius: '8px',
              border: '2px dashed #dee2e6'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.3 }}>👥</div>
              <p style={{ color: '#666', fontSize: '16px', margin: 0 }}>
                No employees found. Add your first employee to get started.
              </p>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{
                width: '100%',
                borderCollapse: 'separate',
                borderSpacing: '0 8px'
              }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e1e8ed' }}>
                    <th style={{ padding: '12px', textAlign: 'left', color: '#666', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase' }}>Employee #</th>
                    <th style={{ padding: '12px', textAlign: 'left', color: '#666', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase' }}>Name</th>
                    <th style={{ padding: '12px', textAlign: 'center', color: '#666', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase' }}>DOGE</th>
                    <th style={{ padding: '12px', textAlign: 'center', color: '#666', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase' }}>BTC</th>
                    <th style={{ padding: '12px', textAlign: 'center', color: '#666', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase' }}>LTC</th>
                    <th style={{ padding: '12px', textAlign: 'left', color: '#666', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase' }}>Notes</th>
                    <th style={{ padding: '12px', textAlign: 'left', color: '#666', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {employees.map((employee) => (
                    <tr key={employee.id} style={{
                      background: 'white',
                      border: '1px solid #e1e8ed',
                      borderRadius: '8px',
                      transition: 'all 0.2s'
                    }}>
                      <td style={{ padding: '16px', borderTop: '1px solid #e1e8ed', borderBottom: '1px solid #e1e8ed', borderLeft: '1px solid #e1e8ed', borderRadius: '8px 0 0 8px' }}>
                        {employee.employee_number || <span style={{ color: '#999' }}>-</span>}
                      </td>
                      <td style={{ padding: '16px', borderTop: '1px solid #e1e8ed', borderBottom: '1px solid #e1e8ed', fontWeight: '600', color: '#333' }}>
                        {employee.employee_name}
                      </td>
                      <td style={{ padding: '16px', borderTop: '1px solid #e1e8ed', borderBottom: '1px solid #e1e8ed', textAlign: 'center' }}>
                        {employee.doge_address ? (
                          <span style={{ color: '#28a745', fontSize: '18px' }}>✓</span>
                        ) : (
                          <span style={{ color: '#999' }}>-</span>
                        )}
                      </td>
                      <td style={{ padding: '16px', borderTop: '1px solid #e1e8ed', borderBottom: '1px solid #e1e8ed', textAlign: 'center' }}>
                        {employee.btc_address ? (
                          <span style={{ color: '#28a745', fontSize: '18px' }}>✓</span>
                        ) : (
                          <span style={{ color: '#999' }}>-</span>
                        )}
                      </td>
                      <td style={{ padding: '16px', borderTop: '1px solid #e1e8ed', borderBottom: '1px solid #e1e8ed', textAlign: 'center' }}>
                        {employee.ltc_address ? (
                          <span style={{ color: '#28a745', fontSize: '18px' }}>✓</span>
                        ) : (
                          <span style={{ color: '#999' }}>-</span>
                        )}
                      </td>
                      <td style={{ padding: '16px', borderTop: '1px solid #e1e8ed', borderBottom: '1px solid #e1e8ed', fontSize: '13px', color: '#666' }}>
                        {employee.notes || <span style={{ color: '#999' }}>-</span>}
                      </td>
                      <td style={{ padding: '16px', borderTop: '1px solid #e1e8ed', borderBottom: '1px solid #e1e8ed', borderRight: '1px solid #e1e8ed', borderRadius: '0 8px 8px 0' }}>
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                          <button
                            onClick={() => this.handleShowEditModal(employee)}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: '#007bff',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => this.handleShowPayoutHistory(employee)}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: '#17a2b8',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}
                          >
                            History
                          </button>
                          <button
                            onClick={() => this.handleDeleteEmployee(employee)}
                            style={{
                              padding: '6px 12px',
                              backgroundColor: '#dc3545',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}
                          >
                            Deactivate
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div> {/* End scrollable content area */}
        </div> {/* End outer container */}

        {/* Modals - rendered outside main container */}
        {/* Add Employee Modal */}
        <Modal show={showAddModal} onHide={this.handleCloseAddModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Add New Employee</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderEmployeeForm()}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseAddModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.handleAddEmployee}>
              Add Employee
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Employee Modal */}
        <Modal show={showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Edit Employee</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderEmployeeForm()}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.handleUpdateEmployee}>
              Update Employee
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Payout History Modal */}
        <Modal show={showPayoutHistoryModal} onHide={this.handleClosePayoutHistory} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              Payout History - {selectedEmployee?.employee_name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ display: 'flex', gap: '12px', marginBottom: '20px', flexWrap: 'wrap' }}>
              <div style={{ flex: '1 1 200px' }}>
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  value={filterStartDate}
                  onChange={(e) => this.setState({ filterStartDate: e.target.value })}
                />
              </div>
              <div style={{ flex: '1 1 200px' }}>
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="date"
                  value={filterEndDate}
                  onChange={(e) => this.setState({ filterEndDate: e.target.value })}
                />
              </div>
              <div style={{ flex: '1 1 200px' }}>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={filterStatus}
                  onChange={(e) => this.setState({ filterStatus: e.target.value })}
                >
                  <option value="all">All</option>
                  <option value="completed">Completed</option>
                  <option value="pending">Pending</option>
                  <option value="failed">Failed</option>
                </Form.Select>
              </div>
              <div style={{ flex: '1 1 200px', display: 'flex', alignItems: 'flex-end' }}>
                <Button
                  variant="primary"
                  onClick={() => this.loadPayoutHistory(selectedEmployee?.id)}
                  style={{ width: '100%' }}
                >
                  Filter
                </Button>
              </div>
            </div>

            {payouts.length === 0 ? (
              <div className="text-center text-muted py-4">
                No payout history found for this employee.
              </div>
            ) : (
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Shift</th>
                    <th>DOGE</th>
                    <th>BTC</th>
                    <th>LTC</th>
                    <th>Pool Total</th>
                    <th>Employees</th>
                    <th>Status</th>
                    <th>TX Hash</th>
                  </tr>
                </thead>
                <tbody>
                  {payouts.map((payout) => (
                    <tr key={payout.id}>
                      <td>{this.formatDate(payout.payout_date)}</td>
                      <td className="small">{payout.shift_identifier || '-'}</td>
                      <td>{this.formatCryptoAmount(payout.tip_doge, 'doge')}</td>
                      <td>{this.formatCryptoAmount(payout.tip_btc, 'btc')}</td>
                      <td>{this.formatCryptoAmount(payout.tip_ltc, 'ltc')}</td>
                      <td className="small text-muted">
                        {payout.total_pool_doge > 0 && `${this.formatCryptoAmount(payout.total_pool_doge, 'doge')} DOGE `}
                        {payout.total_pool_btc > 0 && `${this.formatCryptoAmount(payout.total_pool_btc, 'btc')} BTC `}
                        {payout.total_pool_ltc > 0 && `${this.formatCryptoAmount(payout.total_pool_ltc, 'ltc')} LTC`}
                      </td>
                      <td>{payout.employees_count}</td>
                      <td>
                        <span className={`badge bg-${
                          payout.payout_status === 'completed' ? 'success' :
                          payout.payout_status === 'pending' ? 'warning' :
                          'danger'
                        }`}>
                          {payout.payout_status}
                        </span>
                      </td>
                      <td className="small">
                        {payout.transaction_hash_doge && (
                          <div>DOGE: {payout.transaction_hash_doge.substring(0, 10)}...</div>
                        )}
                        {payout.transaction_hash_btc && (
                          <div>BTC: {payout.transaction_hash_btc.substring(0, 10)}...</div>
                        )}
                        {payout.transaction_hash_ltc && (
                          <div>LTC: {payout.transaction_hash_ltc.substring(0, 10)}...</div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClosePayoutHistory}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  render() {
    const {
      storeName,
      employees,
      payouts,
      loading,
      showAddModal,
      showEditModal,
      showPayoutHistoryModal,
      selectedEmployee,
      filterStartDate,
      filterEndDate,
      filterStatus,
      error
    } = this.state;

    if (loading) {
      return (
        <div className="admin-container">
          <div className="admin-header">
            <h1>Employee Management</h1>
            <button className="home-button" onClick={() => window.location.href = '/admin'}>
              Admin
            </button>
          </div>
          <div className="admin-section">
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <div style={{
                border: '4px solid #f3f3f3',
                borderTop: '4px solid #BA9F33',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                animation: 'spin 1s linear infinite',
                margin: '0 auto'
              }}></div>
              <p style={{ marginTop: '20px', color: '#666' }}>Loading employees...</p>
            </div>
          </div>
        </div>
      );
    }

    if (error && !storeName) {
      return (
        <div className="admin-container">
          <div className="admin-header">
            <h1>Employee Management</h1>
            <button className="home-button" onClick={() => window.location.href = '/admin'}>
              Admin
            </button>
          </div>
          <div className="admin-section" style={{ backgroundColor: '#fee', border: '1px solid #fcc' }}>
            <p style={{ color: '#c00' }}>{error}</p>
            <button className="btn-primary" onClick={() => window.location.href = '/admin'}>
              Go to Admin
            </button>
          </div>
        </div>
      );
    }

    return (
      <>
        {this.renderEmployeeManagement()}
        <style jsx>{`
          .admin-container {
            max-width: 1400px;
            margin: 0 auto;
            padding: 40px 20px;
          }
          .admin-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 30px;
            padding-top: calc(10px + env(safe-area-inset-top, 0px));
            padding-bottom: 20px;
            border-bottom: 2px solid #eee;
          }
          .admin-header h1 {
            margin: 0;
            font-size: 32px;
            color: #333;
          }
          .home-button {
            padding: 10px 24px;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            font-size: 16px;
            font-weight: 500;
            transition: background-color 0.2s;
          }
          .home-button:hover {
            background-color: #0056b3;
          }
          .admin-section {
            background: white;
            border: 1px solid #e1e8ed;
            border-radius: 12px;
            padding: 24px;
            margin-bottom: 20px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          }
          .admin-section h3 {
            margin: 0 0 16px 0;
            font-size: 20px;
            color: #333;
          }
          .btn-primary {
            padding: 12px 24px;
            background-color: #007bff;
            color: white;
            border: none;
            border-radius: 8px;
            cursor: pointer;
            font-size: 15px;
            font-weight: 500;
            transition: background-color 0.2s;
          }
          .btn-primary:hover {
            background-color: #0056b3;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          tbody tr {
            transition: all 0.2s ease;
          }
          tbody tr:hover {
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
            transform: translateY(-2px);
          }
          button {
            transition: all 0.15s ease;
          }
          button:hover {
            opacity: 0.9;
            transform: translateY(-1px);
          }
          button:active {
            transform: translateY(0);
          }
        `}</style>
      </>
    );
  }
}

export default Employees;
